<div class="evaluations">
	<div class="evaluations__body">
		<div class="zk-flex">
			<span class="body__title zk-pb-8"
				>{{ 'EVALUATIONS.JOURNEY_EVALUATIONS' | translate }}
			</span>
			<!-- <div class="zk-gap-2 know-more__button zk-hidden md:zk-flex">
				<h6>{{ 'EVALUATIONS.KNOW_MORE' | translate }}</h6>
				<span class="freud-icon freud-icon-external-link freud-icon-md"></span>
			</div> -->
		</div>
		<div class="evaluations__list" *ngIf="!isLoading && !hasError">
			<evaluation-answer-card
				*ngFor="let evaluation of evaluations"
				[title]="evaluation.title"
				[date]="evaluation.answeredAt"
				[instruments]="evaluation.instruments"
				(openDetail)="openDetail(evaluation.id)"
			></evaluation-answer-card>
		</div>
		<div class="zk-h-72 zk-flex zk-items-center zk-justify-center">
			<div
				class="evaluations__empty"
				*ngIf="(!isLoading && hasError) || (!isLoading && !hasData)"
			>
				<span *ngIf="hasError">{{
					'EVALUATIONS.EMPTY_STATE.ERROR' | translate
				}}</span>
				<span *ngIf="hasData">{{
					'EVALUATIONS.EMPTY_STATE.NO_DATA' | translate
				}}</span>
			</div>
			<div class="evaluations__loading" *ngIf="isLoading">
				<freud-loader></freud-loader>
			</div>
		</div>
	</div>
</div>
<evaluation-answer-detail
	[isOpen]="isEvaluationDetailOpen"
	[evaluationId]="selectedEvaluationId"
	[contactId]="contactId"
	(closeModal)="isEvaluationDetailOpen = false"
></evaluation-answer-detail>
